import { prepareConfig, buildResponsiveState } from './buildResponsiveState';

/**
 * Server-side media value detection based on initial values
 * @param {string} initialValue - Initial value to use
 * @param {string} fallback - Fallback value
 * @returns {string} Media value
 */
function getServerMediaValue(initialValue, fallback) {
  return initialValue || fallback;
}

/**
 * Calculate device responsive state (Server Component compatible)
 *
 * ⚠️ SSR ONLY: This function is designed for Server-Side Rendering and does NOT support matchMedia.
 * For client-side responsive detection, use ResponsiveState class instead.
 *
 * @param {Object} params - Calculation parameters
 * @param {string} params.initialMediaType - Initial media type for SSR
 * @param {string} params.initialOrientation - Initial orientation for SSR
 * @param {Object} params.options - Configuration options (breakpoints, etc.)
 * @returns {Object} Calculated device responsive state
 */
export function calculateResponsiveState(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    initialMediaType = _ref.initialMediaType,
    initialOrientation = _ref.initialOrientation,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options;
  var _prepareConfig = prepareConfig(options),
    config = _prepareConfig.config,
    mediaOrder = _prepareConfig.mediaOrder;
  var mediaType = 'xs'; // mobile first!
  var orientation = config.orientation; // allow constructor defined orientation

  mediaType = getServerMediaValue(initialMediaType, 'xs');
  orientation = getServerMediaValue(initialOrientation, config.orientation);
  return buildResponsiveState({
    mediaType: mediaType,
    orientation: orientation,
    config: config,
    mediaOrder: mediaOrder
  });
}